import { render, staticRenderFns } from "./inventory_wms.vue?vue&type=template&id=40a473bb&scoped=true&"
import script from "./inventory_wms.vue?vue&type=script&lang=js&"
export * from "./inventory_wms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a473bb",
  null
  
)

export default component.exports